module.exports = __webpack_public_path__ + "static/media/Server-Colour.4ff19963.svg";